// import React from 'react';
import './container.css'

const ImgContainer = ({ children, ...rest }) => {
    return (
        <div className='container-img' {...rest}>
            {children}
        </div>
    );
}
export default ImgContainer; //